// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"675f41c0","450":"3020ca0d"}[chunkId] + ".chunk.js";
};